import { render, staticRenderFns } from "./attributes-ranking-list.component.vue?vue&type=template&id=1e520140&scoped=true"
import script from "./attributes-ranking-list.component.vue?vue&type=script&lang=ts"
export * from "./attributes-ranking-list.component.vue?vue&type=script&lang=ts"
import style0 from "./attributes-ranking-list.component.vue?vue&type=style&index=0&id=1e520140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e520140",
  null
  
)

export default component.exports